import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import {
  FaRocket,
  FaHandshake,
  FaLightbulb,
  FaShieldAlt,
  FaArrowRight,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import './About.css';

const values = [
  {
    icon: <FaRocket />,
    title: 'Performance',
    desc: 'Des solutions rapides, optimisées et pensées pour la conversion.',
  },
  {
    icon: <FaHandshake />,
    title: 'Proximité',
    desc: 'Un interlocuteur unique, disponible et à votre écoute tout au long du projet.',
  },
  {
    icon: <FaLightbulb />,
    title: 'Innovation',
    desc: 'Les technologies les plus récentes pour des solutions modernes et pérennes.',
  },
  {
    icon: <FaShieldAlt />,
    title: 'Fiabilité',
    desc: 'Code propre, testé et sécurisé. Maintenance et accompagnement sur la durée.',
  },
];

const zones = [
  'Béziers',
  'Agde',
  'Montpellier',
  'Sète',
  'Narbonne',
  'Toulouse',
  'Hérault (34)',
  'Toute la France',
];

const About = () => {
  return (
    <main className="page-about">
      <Helmet>
        <title>À Propos - Agence Web & Mobile Agde, Hérault | AGKG Créations</title>
        <meta name="description" content="AGKG Créations, agence de développement web et mobile basée à Agde (Hérault). Création de sites internet et applications sur mesure pour entreprises, artisans et startups. Béziers, Montpellier, France." />
        <link rel="canonical" href="https://agkgcreations.fr/a-propos" />
        <meta property="og:title" content="À Propos - AGKG Créations, Agence Web Hérault" />
        <meta property="og:description" content="Votre partenaire digital à Agde. Création de sites web et applications mobiles sur mesure." />
        <meta property="og:url" content="https://agkgcreations.fr/a-propos" />
      </Helmet>

      <section className="page-hero">
        <div className="container">
          <h1 className="section-title">
            À <span>propos</span>
          </h1>
          <p className="section-subtitle">
            Découvrez AGKG Créations, votre partenaire digital dans l'Hérault
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="about-intro">
            <div className="about-intro-content">
              <h2>
                Votre partenaire <span className="gradient-text">digital</span> de confiance
              </h2>
              <p>
                AGKG Créations est une agence de développement web et mobile basée à
                Agde, dans l'Hérault. Nous accompagnons les entreprises, artisans, commerçants et
                startups dans leur transformation digitale.
              </p>
              <p>
                Notre expertise couvre la création de sites vitrines, de boutiques e-commerce,
                d'applications web métier et d'applications mobiles Android & iOS. Chaque
                projet est conçu sur mesure pour répondre précisément à vos besoins et
                objectifs.
              </p>
              <p>
                Nous privilégions une approche directe et transparente : un seul
                interlocuteur, des délais respectés et un accompagnement de A à Z.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section about-values-section">
        <div className="container">
          <h2 className="section-title">
            Nos <span>valeurs</span>
          </h2>
          <p className="section-subtitle">
            Ce qui nous guide au quotidien dans chaque projet
          </p>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">{value.icon}</div>
                <h3>{value.title}</h3>
                <p>{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section about-zones">
        <div className="container">
          <h2 className="section-title">
            Zone <span>d'intervention</span>
          </h2>
          <p className="section-subtitle">
            Nous intervenons localement et dans toute la France
          </p>
          <div className="zones-grid">
            {zones.map((zone, index) => (
              <div key={index} className="zone-badge">
                <FaMapMarkerAlt /> {zone}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-box">
            <h2>Prêt à lancer votre projet ?</h2>
            <p>
              Contactez-nous pour discuter de votre projet. Devis gratuit et sans engagement.
            </p>
            <Link to="/contact" className="btn btn-primary">
              Nous contacter <FaArrowRight />
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
